export interface PromptsGetResponse {
    count: number;
    total_pages: number;
    current_page: number;
    next: any;
    previous: any;
    results: [Prompt];
}

export interface Prompt {
    id: number;
    node: Node;
    prompt: string;
    date_created: string;
    last_updated: string;
    is_active: boolean;
    is_default: boolean;
    tag: string | null;
}

export interface NodesGetResponse {
    count: number;
    total_pages: number;
    current_page: number;
    next: any;
    previous: any;
    results: [Prompt];
}

export interface Node {
    id: number;
    node_name: string;
    model: string;
    base_url: string;
    temperature: number;
}

export const FAV_TAG = "fav";